/** This saga is to debounce effects from mui-rte update */
import { put, debounce } from "redux-saga/effects";
import { setHoverAction, setClickActionBoxContent } from "../index";
import {
  setClickActionBoxContentDebounced,
  setHoverActionDebounced,
} from "./sagasActions";

//== HOVER ACTION CONF
function* setHoverActionDebouncedWorker(action) {
  yield put(setHoverAction(action.payload));
}

export function* setHoverActionDebouncedWatcher() {
  yield debounce(
    1000,
    setHoverActionDebounced().type,
    setHoverActionDebouncedWorker
  );
}

//== CLICK ACTION CONF
function* setClickActionBoxContentDebouncedWorker(action) {
  yield put(setClickActionBoxContent(action.payload));
}

export function* setClickActionBoxContentDebouncedWatcher() {
  yield debounce(
    1000,
    setClickActionBoxContentDebounced().type,
    setClickActionBoxContentDebouncedWorker
  );
}
